var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabIndex === 1)?_c('div',{staticClass:"p-3"},[_c('FormHelper',{ref:"form",attrs:{"form":_vm.form,"config":_vm.config,"no-data-text":_vm.$t('mapping.noTransformersAvailable')},on:{"change":_vm.updateTransformerConditions},model:{value:(_vm.formCondition),callback:function ($$v) {_vm.formCondition=$$v},expression:"formCondition"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }